import { Body } from "@hypercard/web-components";
import { Uploader } from "./Uploader";
import { File, X } from "@phosphor-icons/react";

export const handleOnDrop = (
  acceptedFiles: FileList | null,
  onUpload: (file: any) => void,
  onClearError: () => void,
  onError: () => void,
  accept: string,
) => {
  const handleError = () => {
    onUpload(null);
    onError();
  };

  if (!acceptedFiles || acceptedFiles.length !== 1) {
    handleError();
    return;
  }

  const fileExtension = acceptedFiles[0].type.split("/")[1];
  const isValidFileType = accept.includes(fileExtension);
  if (!isValidFileType) {
    handleError();
  } else {
    onUpload(acceptedFiles[0]);
    onClearError();
  }
};

interface Props {
  loading?: boolean;
  value: any;
  field: any;
  onUpload: (file: any) => void;
  onClearError: () => void;
  onError: () => void;
  accept: string;
  dropMessage?: string;
}

export const Dropzone = ({
  loading,
  value,
  field,
  onUpload,
  onClearError,
  onError,
  dropMessage = "Drop file or click here to upload",
  accept,
}: Props) => {
  return (
    <div>
      {loading && value ? (
        <div className="relative flex items-center justify-center gap-3 p-4">
          <Body size="md" weight="medium">
            Uploading file...
          </Body>
        </div>
      ) : value ? (
        <div className="relative flex items-center justify-center gap-3 p-4">
          <File className="size-4 shrink-0" />
          <Body size="md" weight="medium" className="truncate">
            {value?.name || "File Uploaded"}
          </Body>
          <X
            className="size-4 shrink-0 cursor-pointer"
            onClick={() => onUpload(null)}
          />
        </div>
      ) : (
        <Uploader
          {...field}
          disabled={loading}
          loading={loading}
          dropMessage={dropMessage}
          accept={accept}
          handleOnDrop={(files: any) =>
            handleOnDrop(files, onUpload, onClearError, onError, accept)
          }
        />
      )}
    </div>
  );
};
